import { render, staticRenderFns } from "./AnnouncementNetwork.vue?vue&type=template&id=be79a722&scoped=true&"
import script from "./AnnouncementNetwork.vue?vue&type=script&lang=js&"
export * from "./AnnouncementNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be79a722",
  null
  
)

export default component.exports